<h1 class="px-3 f-18 f-md-24 font-weight-normal mb-0 text-truncate text-elipsis">
  {{ title }}
</h1>

<div
  *ngIf="enviromentAmbiente == 'homologacao'"
  class="menu-container hml"
  ngbDropdown
  style="background-color: red;"
  placement="bottom-right"
>
  <div
    class="d-flex align-items-center btn hml"
    id="dropdownUserMenu"
    ngbDropdownToggle
  >
    <h3 class="mb-0 font-weight-normal hml" style="color: white;">
      Você se encontra em ambiente de homologação
    </h3>
  </div>
</div>

<div
  class="menu-container"
  ngbDropdown
  #myDrop="ngbDropdown"
  placement="bottom-right"
>
  <div>
    <!-- WhatsApp Zendesk inicio -->
    <!--
    <iframe
      width="60"
      height="30"
      style="border: 0"
      src="https://cdn.smooch.io/message-us/index.html?channel=whatsapp&color=green&size=compact&radius=40px&number=5511963056359"
    ></iframe>
    -->
    <!-- WhatsApp Zendesk fim -->
  </div>

  <div
    class="d-flex align-items-center btn"
    id="dropdownUserMenu"
    ngbDropdownToggle
  >
    <div class="text-right">
      <h3 class="mb-0 font-weight-normal">{{ usuario?.nome }}</h3>
      <h5 class="font-weight-normal text-muted mb-0">
        {{ usuario?.unidade?.nomeFantasia }}
      </h5>
    </div>
    <div class="pr-md-2 pl-2">
      <i class="mdi mdi-account-circle text-theme"></i>
    </div>
  </div>

  <div
    class="dropdown-menu"
    ngbDropdownMenu
    aria-labelledby="dropdownUserMenu"
  >
  <!-- REMOVIDO #10132
    <a
      class="dd-item d-flex align-items-center no-outline"
      [routerLink]="['/unidade', 'editar', usuario?.unidade?.id]"
      (click)="myDrop.close()"
      role="menuitem"
    >
      <i class="mdi mdi-settings pr-3 mdi-21px"></i>
      <div>Configurações</div>
    </a>
  -->

    <a
      class="dd-item d-flex align-items-center no-outline"
      [routerLink]="['/unidade','usuario','alterar-minha-senha']"
      (click)="myDrop.close()"
      role="menuitem"
    >
      <i class="mdi mdi-lock pr-3 mdi-21px"></i>
      <div>Alterar senha</div>
    </a>

    <div class="dropdown-divider"></div>

    <a
      class="dd-item d-flex align-items-center no-outline"
      [routerLink]="['/logout']"
      (click)="myDrop.close()"
      role="menuitem"
    >
      <i class="mdi mdi-exit-to-app text-danger pr-3"></i>
      <div>Sair</div>
    </a>
  </div>
</div>
